/**
 * **Localization: the contract** (docs/I18N.md). A pure layer: no Drizzle, no
 * Next, no React. The domain, the server, the read layer, components and
 * scripts all import it. The React glue (`useT`, `useLocale`) lives in
 * src/lib/locale-context.tsx; the server's per-request locale in
 * src/lib/viewer.ts (`getLocale`, `getT`).
 */
export type {
  Arg,
  ArgsOf,
  ArgsParam,
  Catalog,
  Entry,
  Message,
  MessageKey,
  PlainKey,
  PluralCategory,
  PluralEntry,
} from './catalog';
export { format, formatParts, isMessageKey, m, sentences, translator, verbatim } from './format';
export type { RichArgs, Translator } from './format';
export {
  dateLocaleFor,
  DEFAULT_LOCALE,
  isLocale,
  LOCALE_NAMES,
  LOCALES,
  resolveLocale,
} from './locale';
export type { Locale } from './locale';
